import { render, staticRenderFns } from "./travelCateList.vue?vue&type=template&id=10411570&scoped=true&"
import script from "./travelCateList.vue?vue&type=script&lang=js&"
export * from "./travelCateList.vue?vue&type=script&lang=js&"
import style0 from "./travelCateList.vue?vue&type=style&index=0&id=10411570&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10411570",
  null
  
)

export default component.exports